export const beforeSubmitDataValidation = data => {
  Object.keys(data).map(k => {
    let entity = data[k];
    if (typeof entity == 'string') {
      if (!!entity.match(/^\+380 (?:\(\d{2}\)|\d{2}) \d{3} \d{2} \d{2}$/) || !!entity.match(/^\+1 (?:\(\d{3}\)|\d{3}) \d{3}-\d{4}$/) || !!entity.match(/^\+1(\d{3}-\d{3}-\d{4})$/) || !!entity.match(/\+\d{4}-\d{3}-\d{4}/) || !!entity.match(/\+\d{5}-\d{3}-\d{4}/)) {
        entity = entity.trim().replace(/[^0-9+]|("")/g, '');
      }
      entity = entity.trim();
    }
    data[k] = entity;
  });
  return data;
};